'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.5.0@rc-checkbox/lib/index.js
 ** module id = 172
 ** module chunks = 0 1
 **/